import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { RFSTable } from "@/features/rfs/RFSTable";

export function RFSIndex() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "RFS",
          },
          {
            href: "/rfs/rfs",
            label: "RFS List",
          },
        ]}
      />
      <H2>RFS List</H2>
      <RFSTable />
    </>
  );
}
